import overtime from '~/assets/overtime.svg';
import React from 'react';

export function DidYouMiss() {
  return (
    <div className={'flex-0 bg-gray-100 rounded-2xl p-4 flex items-center '}>
      <img src={overtime} alt={'Working overtime'} className={'mr-4'} />

      <div>
        <h2 className={'font-bold text-lg'}>Did you miss the live?</h2>
        <p className={'text-gray-700'}>
          Enter your mobile # and get a text next time we go live!
        </p>
      </div>
    </div>
  );
}
